import { render, staticRenderFns } from "./AbkEventTextSection.vue?vue&type=template&id=337e63ba&scoped=true&"
import script from "./AbkEventTextSection.vue?vue&type=script&lang=js&"
export * from "./AbkEventTextSection.vue?vue&type=script&lang=js&"
import style0 from "./AbkEventTextSection.vue?vue&type=style&index=0&id=337e63ba&lang=scss&scoped=true&"
import style1 from "./AbkEventTextSection.vue?vue&type=style&index=1&id=337e63ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337e63ba",
  null
  
)

export default component.exports